import { SignupAcknowledgement } from "@components/signup/signup-acknowledgement";
import { PageTitle } from "@components/common/page-title";
import { UlmContainer } from "@components/ulm/ulm-container";
import { useState } from "react";
import { TrialFormData, TrialStep } from "@pages/trial/trial-types";
import { TrialStepOne } from "@pages/trial/trial-step-one";
import { TrialStepTwo } from "@pages/trial/trial-step-two";
import { TrialStepThree } from "@pages/trial/trial-step-three";

/**
 * Page component that handles registration flow for users starting
 * a free trial.
 */
export function Trial(): JSX.Element {
  const [step, setStep] = useState<TrialStep>("one");
  const [formData, setFormData] = useState<TrialFormData>({});

  return (
    <UlmContainer>
      <PageTitle>Start free trial</PageTitle>
      {step === "one" && (
        <TrialStepOne
          setFormData={setFormData}
          setStep={setStep}
          email={formData.email}
        />
      )}
      {step === "two" && formData.email && formData.server && (
        <TrialStepTwo
          setFormData={setFormData}
          setStep={setStep}
          email={formData.email}
          server={formData.server}
        />
      )}
      {step === "three" &&
        formData.email &&
        formData.server &&
        formData.authMethod && (
          <TrialStepThree
            setStep={setStep}
            email={formData.email}
            authMethod={formData.authMethod}
          />
        )}
      <SignupAcknowledgement />
    </UlmContainer>
  );
}
